const emailDomains = [
  '@gmail.com',
  '@hotmail.co.jp',
  '@yahoo.com',
  '@yahoo.co.jp',
  '@i.softbank.jp',
  '@yahoo.ne.jp',
  '@hotmail.com',
  '@itscom.net',
  '@ybb.ne.jp',
  '@outlook.com',
  '@live.jp',
  '@ymail.ne.jp',
  '@icloud.com',
  '@mac.com',
  '@ymobile.ne.jp',
  '@asahinet.jp',
  '@me.com',
  '@zaq.ne.jp',
  '@au.com',
  '@mineo.jp',
  '@aol.com',
  '@auone-net.jp',
  '@msn.com',
  '@comcast.net',
  '@bbiq.jp',
  '@nifty.com',
  '@live.com',
  '@biglobe.ne.jp',
  '@nifty.ne.jp',
  '@att.net',
  '@commufa.jp',
  '@ocn.ne.jp',
  '@mail.ru',
  '@cyberhome.ne.jp',
  '@odn.ne.jp',
  '@googlemail.com',
  '@dion.ne.jp',
  '@outlook.jp',
  '@ymail.com',
  '@disney.ne.jp',
  '@plala.or.jp',
  '@web.de',
  '@docomo.ne.jp',
  '@rakumail.jp',
  '@gmx.net',
  '@dti.ne.jp',
  '@rakuten.jp',
  '@protonmail.com',
  '@em-net.ne.jp',
  '@softbank.ne.jp',
  '@yandex.ru',
  '@enjoy.ne.jp',
  '@so-net.ne.jp',
  '@rediffmail.com',
  '@eonet.ne.jp',
  '@spice.or.jp',
  '@yahoo.co.in',
  '@ezweb.ne.jp',
  '@t-com.ne.jp',
  '@sbcglobal.net',
  '@goo.ne.jp',
  '@tnc.ne.jp',
  '@libero.it',
  '@gyao.ne.jp',
  '@uqmobile.jp',
  '@qq.com',
  '@hi-ho.ne.jp',
  '@vodafone.ne.jp',
  '@126.cn',
  '@home.ne.jp',
  '@wakwak.com',
  '@gamil.com',
  '@yshoo.com',
  '@hotmail.con',
  '@icloud.con',
  '@outlok.com',
  '@concast.net',
  '@yhoo.com',
] as const;

export type EmailDomain = (typeof emailDomains)[number];

export interface UseEmailDomainSuggestReturn {
  getSuggestions: (input: string) => string[];
}

export const useEmailDomainSuggest = (): UseEmailDomainSuggestReturn => {
  const getSuggestions = (input: string): string[] => {
    if (!input) return [];

    const atIndex = input.indexOf('@');
    if (atIndex === -1) return [];

    const localPart = input.substring(0, atIndex);
    const domainPart = input.substring(atIndex);

    if (!localPart) return [];

    const matchingDomains = emailDomains.filter((domain) =>
      domain.toLowerCase().startsWith(domainPart.toLowerCase()),
    );

    return matchingDomains.map((domain) => `${localPart}${domain}`);
  };

  return {
    getSuggestions,
  };
};
